import { BlocksBreadcrumbsItem } from 'blocks-nextjs/blocks-web-components/components/breadcrumbs-item/breadcrumbs-item';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatBreadcrumbsItem = createComponent({ react: React, tagName: 'cat-breadcrumbs-item', elementClass: BlocksBreadcrumbsItem });
